import { createFileRoute } from "@tanstack/react-router";

import { AdminReviewPage } from "@/components/AdminReviewPage";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
// Карточка «как увидят родители» — те же стили, что на карте.
import tmCss from "@/components/partners/tutors-map.css?url";

// /admin/review/<id> — проверка новой анкеты или правки в одно нажатие
// (src/components/AdminReviewPage.tsx). «_» после admin — не вкладывать в
// страницу /admin: у неё нет <Outlet/>. noindex.
export const Route = createFileRoute("/admin_/review/$id")({
  head: () => ({
    meta: [{ title: "Проверка — Yolutap" }, { name: "robots", content: "noindex, nofollow" }, { name: "referrer", content: "no-referrer" }],
    links: [...SITE_CHROME_LINKS, { rel: "stylesheet", href: tmCss }],
  }),
  component: function Page() {
    const { id } = Route.useParams();
    return <AdminReviewPage key={id} id={id} />;
  },
});
